/**
 * Created by Jerker Nord on 2018-06-28.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite} from "gsap";
import {IceIceYetiGameConfig} from "../../IceIceYetiGameConfig";
import {IceIceYetiParsedGameData} from "../../server/data/IceIceYetiParsedGameData";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {IceIceYetiToggleWinNumber} from "../../pool/IceIceYetiToggleWinNumber";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {IceIceYetiWinTogglePool} from "../../pool/IceIceYetiWinTogglePool";

export class IceIceYetiInitialToggleWPView extends BaseView {

    private _layer: ScalableLayer;
    private _toggleWinMainTimeline: TimelineLite | null;
    private _onWinAnimationCompleteCallback: Function;
    private _activeGameAreaAfterSpin: boolean[][];
    private _betWayWins: IBetWayWinData[];

    constructor() {
        super();
        this._layer = StageManager.getLayer(IceIceYetiGameConfig.instance.LAYERS.BET_LINES.name);
    }

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    protected onGameDataParsed(data: IceIceYetiParsedGameData): void {
        this._activeGameAreaAfterSpin = data.activeGameAreaAfterSpin;
        this._betWayWins = <IBetWayWinData[]><unknown>data.betWins;
    }

    protected initAnimations(): void {
        this._layer.addChild(this);
        this._toggleWinMainTimeline = new TimelineLite({
            paused: true,
            onComplete: () => this.onWinPresentationComplete()
        });
    }

    private getTopRightPosition(reelWinPosition: boolean[][]): PIXI.Point {
        const position: PIXI.Point = new PIXI.Point(0, 0);
        let reel: number = 0;
        let row: number = 99;
        for (let i: number = 0; i < reelWinPosition.length; i++) {
            for (let j: number = 0; j < reelWinPosition[i].length; j++) {
                if (reelWinPosition[i][j] == true) {
                    if (i > reel) {
                        reel = i;
                        row = j;
                    }
                    if (j < row) {
                        row = j;
                    }
                }
            }
        }

        position.x = Helper.getSymbolPositions(reel, row)[0];
        position.y = Helper.getSymbolPositions(reel, row)[1];

        return position;
    }

    private onWinPresentationComplete(): void {
        this._onWinAnimationCompleteCallback();
    }

    public playWinPresentation(winPresCompleteCallback: Function): void {
        this._onWinAnimationCompleteCallback = winPresCompleteCallback;
        let winNumber: IceIceYetiToggleWinNumber;

        for (let i: number = 0; i < this._betWayWins.length; i++) {
            const winComboTL: TimelineLite = new TimelineLite();

            for (let k: number = 0; k < this._betWayWins[i].reelWinPositions.length; k++) {
                const symbolComboTL: TimelineLite = new TimelineLite();
                for (let j: number = 0; j < this._betWayWins[i].reelWinPositions.length; j++) {
                    if (this._betWayWins[i].reelWinPositions[k][j] == true) {
                        symbolComboTL.add(() => Reels.getSymbol(k, j)!.changeState({
                            state: IceIceYetiGameConfig.instance.SYMBOL_STATES.win,
                            fadeInDuration: 0.1
                        }));
                    } else {
                        if (this._activeGameAreaAfterSpin[k][j] == true) {
                            symbolComboTL.add(() => Reels.getSymbol(k, j)!.changeState({
                                state: IceIceYetiGameConfig.instance.SYMBOL_STATES.noWin,
                                fadeInDuration: 0.1
                            }));
                        }
                    }
                }
                symbolComboTL.add(() => {
                    winNumber = IceIceYetiWinTogglePool.getWinToggleNumber(this._betWayWins[i].multipliedAmount, this._betWayWins[i].numberOfCombinations);
                    winNumber.position = this.getTopRightPosition(this._betWayWins[i].reelWinPositions);
                    winNumber.visible = true;
                    this.addChild(winNumber);
                });
                winComboTL.add(symbolComboTL);
            }
            this._toggleWinMainTimeline?.add(winComboTL);
            this._toggleWinMainTimeline?.add(new TimelineLite({delay: 0.5}));
        }
        for (let i: number = 0; i < 5; i++) {
            for (let j: number = 0; j < 8; j++) {
                this._toggleWinMainTimeline?.add(() => Reels.getSymbol(i, j)!.changeState({
                    state: IceIceYetiGameConfig.instance.SYMBOL_STATES.noWin,
                    fadeInDuration: 0.01
                }));
            }
        }
        this._toggleWinMainTimeline?.add(() => winNumber.visible = false);
        this._toggleWinMainTimeline?.add(new TimelineLite({delay: 0.2}));
        this._toggleWinMainTimeline?.play();
    }

    public stopWinPresentation():void{
        if (this._toggleWinMainTimeline){
            this._toggleWinMainTimeline.progress(1);
            this._toggleWinMainTimeline.kill();
        }
    }
}